export default __webpack_public_path__ + "static/media/accomm_img_3.1658fdfb.JPG";